<template>
    <el-dialog id="myDdialog" title="任务总结" top="0px"  :visible.sync="summaryTaskDialogVisible" width="800px" center append-to-body>
        <div class="mySummaryTip">
            <el-row style="padding-left: 18px;">
                <el-col :span="24">
                    <span style="font-size: 18px; ">任务编号:&nbsp;&nbsp;{{myTaskCode}}</span>
                </el-col>
            </el-row>
            <el-row style="margin-top: 5px;padding-left: 18px;">
                <el-col :span="24">
                    <span style="font-size: 18px; ">任务标题:&nbsp;&nbsp;{{myTaskName}}</span>
                </el-col>
            </el-row>
        </div>
        <summaryTask :myRowData="myRowData"  ref="summaryTask"></summaryTask>
        <span slot="footer" class="dialog-footer">
            				<!-- <el-progress v-show="process!=0" :percentage='process'></el-progress> -->
            							<el-row>
            								<el-col :span="3" v-show="false">
            								<el-checkbox v-model="ISCOMPLETED">保存至工作总结</el-checkbox>
            								</el-col>
            								<el-col :span="21">
            								<el-button @click="summaryTaskDialogVisible = false">取 消</el-button>
               								<el-button type="primary" :disabled="submitDis" @click="toSummaryTask">{{submitBtn}}</el-button>
              								</el-col>
            							</el-row>
            							</span>
    </el-dialog>
</template>

<script>
    import {
        getToken
    } from "../../../util/auth";
    import {
        mapState
    } from 'vuex';
    import {
        getAllTaskSummaryByTaskId,
        saveTaskSummary,
        UploadFiles
    } from "@/api/modules/basicData/task.js";
    import summaryTask from './summaryTask.vue';
    import {
        Linq,
        DateFormat,
        TimeFormat
    } from '@/util/common'
    const cookieUser = getToken();
    export default {
        components:{
            summaryTask
        },
        data() {
            return {
                summaryTaskDialogVisible: false,
                submitBtn: "保存草稿",
                submitDis: false,
                ISCOMPLETED: false,
                myTaskCode: '',
				myTaskName: '',
                myRowData: {
                    userId: '',
                    taskId: '',
                    taskState: 1,
                },
            }
        },
        computed: {
            ...mapState({
                // userId: state => state.task.userId,
                // ServerCenterIds: state => state.task.ServerCenterIds,
                // createIdentity: state => state.task.createIdentity,
                // contactId: state => state.user.ContactID,
                // realName: state => state.task.realName,
                // departmentId: state => state.user.departmentId,
                // departmentName: state => state.user.departmentName,
                // companyId: state => state.user.companyId,
                // companyName: state => state.user.companyName,
                curTask: state => state.task.curTask
            }),
        },
        methods: {
            lookDetail(userId) {
                //console.log(this.curTask)
                this.submitDis = true
                this.submitBtn = "已完成"
                this.myRowData.taskState = this.curTask.STATE
                this.myRowData.taskId = this.curTask.ID
                this.myRowData.Complete = true
                let dds = ""
                if (this.curTask.CONTENT != null && this.curTask.CONTENT != "") {
                    let dd = this.curTask.CONTENT.replace(/<\/?.+?>/g, "");
                    dds = dd.replace(/ /g, ""); //dds为得到后的内容
                }
                this.myRowData.taskDescreption = dds
                this.myRowData.taskName = this.curTask.TASKNAME
                this.myTaskCode = this.curTask.INSTANCE
                this.myTaskName = this.curTask.TASKNAME
                this.myRowData.userId = userId
                this.summaryTaskDialogVisible = true
            },
            checkIsCompleted(val) {
                this.ISCOMPLETED = val
            },
            TaskSummary() { //打开总结
                if (this.curTask.EXCUTEUSERID != cookieUser.userId) {
                    this.$message({
                        message: '请选择自己执行的任务进行总结',
                        type: 'warning'
                    });
                } else {
                    if (this.curTask.STATE == 1 || this.curTask.STATE == 2) {
                        if (this.curTask.HasSummary == false) {
                            if (this.curTask.STATE == 1) {
                                this.submitBtn = "保存草稿"
                            } else {
                                this.submitBtn = "提交"
                            }
                            let dds = ""
                            if (this.curTask.CONTENT != null && this.curTask.CONTENT != "") {
                                let dd = this.curTask.CONTENT.replace(/<\/?.+?>/g, "");
                                dds = dd.replace(/ /g, ""); //dds为得到后的内容
                            }
                            this.myRowData.Complete = false
                            this.myRowData.taskState = this.curTask.STATE
                            this.myRowData.taskId = this.curTask.ID
                            this.myTaskCode = this.curTask.INSTANCE
                            this.myTaskName = this.curTask.TASKNAME
                            this.myRowData.taskDescreption = dds
                            this.myRowData.taskName = this.curTask.TASKNAME
                            this.myRowData.userId = cookieUser.userId
                            this.submitDis = false
                            this.summaryTaskDialogVisible = true
                        } else {
                            getAllTaskSummaryByTaskId(this.curTask.ID).then(res => {
                                this.allSummary = res
                                this.allSummaryVisible = true
                            })
                        }
                    } else {
                        this.$message({
                            message: '当前任务状态无法总结',
                            type: 'warning'
                        });
                    }
                }
            },
            toSummaryTask() { //完成总结
                let summaryJson =  this.$refs.summaryTask.summaryList
                let isTrue = true
                summaryJson.DetailList.forEach((c) => {
                    if (c.TITLE == "") {
                        isTrue = false
                    }
                    if (c.CONTENT == "") {
                        isTrue = false
                    }
                })
                if (isTrue == false) {
                    this.$message({
                        message: '请填写标题或内容',
                        type: 'info'
                    });
                } else {
                    if (summaryJson.ID == "" || summaryJson.ID == null) {
                        summaryJson.ID = this.Guid() //空的话是新数据，生成ID
                    }
                    var myDate = new Date();
                    summaryJson.TASKID = this.curTask.ID
                    summaryJson.CREATEUSERID = this.curTask.EXCUTEUSERID
                    summaryJson.CREATEUSERNAME = this.curTask.EXCUTEUSERNAME
                    summaryJson.CREATEDEPTID = this.curTask.EXCUTEDEPTID
                    summaryJson.CREATEDEPTNAME = this.curTask.EXCUTEDEPTNAME
                    summaryJson.CREATETIME = myDate.toLocaleString()
                    if (this.curTask.STATE == 1) {
                        summaryJson.ISCOMPLETED = false
                    } else if (this.curTask.STATE == 2) {
                        summaryJson.ISCOMPLETED = true
                    }
                    summaryJson.DetailList.forEach((c) => {
                        c.SUMMARYID = summaryJson.ID
                        if (c.ID == "" || c.ID == null) { //空的话是新数据，生成ID
                            c.ID = this.Guid()
                        }
                        c.DeviceList.forEach((dev) => {
                            //						dev.DEVICEID = dev.SocialId
                            //						dev.DEVICENAME = dev.Name
                            //						dev.DEVICETYPE = this.GetObjType(dev.Type)
                            dev.SUMMARYDETAILID = c.ID
                            //						dev.SERIES = dev.Serial
                            //						dev.LOCATION = dev.AreaName
                        })
                        c.OPobjectList.forEach((obj) => {
                            obj.SUMMARYDETAILID = c.ID
                            //						obj.OPOBJECTID = obj.SocialId
                            //						obj.OPOBJECTNAME = obj.Name
                        })
                    })
                    var _this = this
                    saveTaskSummary(summaryJson).then(res => {
                        if (res.ResultCode == 1) {
                            let newFileLists = _this.$refs.summaryTask.newFileLists
                            for (var i = 0; i < summaryJson.DetailList.length; i++) {
                                if (newFileLists[i].FileList.length > 0) {
                                    _this.uploadFiles(summaryJson.DetailList[i].ID, newFileLists[i].FileList)
                                }
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.summaryTaskDialogVisible = false
                        } else {
                            this.$message({
                                message: '保存出错',
                                type: 'warning'
                            });
                        }
                    }).catch(err => {
                        console.log("saveTaskSummary err");
                    });
                }
            },
            uploadFiles(mainId, FileList) {
                let filesObj = {
                    MainId: mainId,
                    FileType: 11,
                    Person: cookieUser
                }
                var formData = new FormData()
                if (FileList && FileList.length > 0) {
                    for (var i = 0; i < FileList.length; i++) {
                        formData.append(i.toString(), FileList[i])
                    }
                }
                var _this = this
                formData.append('TaskFileUploadModel', JSON.stringify(filesObj))
                //axios.post(url, formData, config).then((res) => {
                UploadFiles(formData).then(res => {}).catch(err => {
                    console.log("saveTaskSummary err");
                });
            },
        }
    }
</script>

<style scoped>
    #myDdialog {
        padding: 2px 25px 30px !important;
    }
    .mySummaryTip {
        background-color: #ecf8ff;
        border-radius: 4px;
        border-left: 5px solid #50bfff;
    }
</style>